import type { Permissions } from "@/shared/generated/graphql";
import { Roles } from "@/shared/@types/Roles";

export const getCustomerRoles = (
  permissions: Permissions,
  selectedCustomerId: string,
) => {
  const roles: Array<Roles> = [];
  if (permissions.fbsUserCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.FBS_USER);
  }
  if (permissions.fleetAtHomeUserCustomerId === selectedCustomerId) {
    roles.push(Roles.FLEET_AT_HOME_USER);
  }
  if (permissions.fleetAtHomeManagerCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.FLEET_AT_HOME_MANAGER);
  }
  if (
    permissions.preSalesManagerEquivoltCustomerIds.includes(selectedCustomerId)
  ) {
    roles.push(Roles.EQUIVOLT_PRE_SALES_MANAGER);
  }
  if (permissions.gasStoremanCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.GAS_STOREMAN);
  }
  if (permissions.gasRequesterCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.GAS_REQUESTER);
  }
  if (permissions.gasOciCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.GAS_OCI_USER);
  }
  if (permissions.globalGasStoremanCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.GLOBAL_GAS_STOREMAN);
  }
  if (permissions.wccManagerCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.WCC_MANAGER);
  }
  if (permissions.wscManagerCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.WSC_MANAGER);
  }
  if (permissions.thgQuoteManagerCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.THG_QUOTE_MANAGER);
  }
  if (permissions.virtaUserCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.VIRTA_USER);
  }
  if (permissions.gaasUserCustomerIds.includes(selectedCustomerId)) {
    roles.push(Roles.GAAS_USER);
  }
  if (
    permissions.westfalenIdAccountManagerCustomerIds.includes(
      selectedCustomerId,
    )
  ) {
    roles.push(Roles.WESTFALEN_ID_ACCOUNT_MANAGER);
  }

  return roles;
};
